import PropertyValue from 'automation-ui-flow-core/fields/PropertyValue';
import * as PropertyValueTypes from 'automation-ui-flow-core/fields/PropertyValueTypes';
import { FormulaFunctionNames } from 'automation-ui-formula-editor/formula-editor/FormulaFunctionDefinitions';
import get from 'immutable-less/transmute/get';
const VARIABLE_PREFIX = 'variable';
export const DEFAULT_HUBL_VARIABLE_NAME = 'dataSource';
const toTokenPrefix = objectTypeId => `_${objectTypeId.replace('-', '_')}`;
export const _defaultPropertyValue = new PropertyValue({});
export const toTemplateString = ({
  hubLFilter,
  propertyValue
}) => {
  const isSet = ![null, undefined, _defaultPropertyValue].includes(propertyValue);
  if (!isSet && !hubLFilter) {
    return '';
  }

  // Only PropertyValueTypes.OBJECT_PROPERTY has propertyName set.
  const hubLVariable = isSet ? `${VARIABLE_PREFIX}.${propertyValue.propertyName || DEFAULT_HUBL_VARIABLE_NAME}` : '';
  return hubLFilter ? `{{${hubLVariable}|${hubLFilter}}}` : `{{${hubLVariable}}}`;
};
const variableAndFilterRegex = /^{{\s*([^|}]*)\s*\|?\s*(.*)}}\s*({#.*#})?$/;
const supportedHubLFiltersRegex = new RegExp(`(${FormulaFunctionNames.join('|')})\\s*(\\(\\s*(.+)\\s*\\))?`);
// Supports single variable and filter for now.
export const fromTemplateString = ({
  objectTypeId,
  formulaTemplate
}) => {
  const parsedVariableAndFilter = {};
  if (!objectTypeId || !formulaTemplate) {
    return parsedVariableAndFilter;
  }
  const matches = formulaTemplate.match(variableAndFilterRegex);
  if (!matches) {
    return parsedVariableAndFilter;
  }
  const [__, variableStr, filterStr] = matches;
  if (variableStr) {
    const variablePrefixAndNameRegex = new RegExp(`(${toTokenPrefix(objectTypeId)}|${VARIABLE_PREFIX}).(\\w+)`);
    const variableMatches = variableStr.match(variablePrefixAndNameRegex);
    if (variableMatches) {
      const [___, prefix, name] = variableMatches;
      parsedVariableAndFilter.variable = {
        isPersonalizationToken: prefix === toTokenPrefix(objectTypeId),
        name
      };
    }
  }
  if (filterStr.trim()) {
    parsedVariableAndFilter.hubLFilter = filterStr.trim();
  }
  return parsedVariableAndFilter;
};
export const findVariableContext = (variable, variableContexts) => {
  if (!variable) {
    return _defaultPropertyValue;
  }
  if (variable.isPersonalizationToken) {
    return new PropertyValue({
      propertyName: variable.name,
      type: PropertyValueTypes.OBJECT_PROPERTY
    });
  }
  const variableContext = variableContexts && variableContexts.find(_variableContex => _variableContex.get('name') === variable.name);
  return get('value', variableContext) || _defaultPropertyValue;
};
const isBooleanRegex = /^(true|false)$/;
const isNumberRegex = /^(-?\d+\.?\d*)$|^(-?\.\d+)$/;
const getTypedValue = param => {
  if (isBooleanRegex.test(param)) {
    return param === 'true';
  }
  if (isNumberRegex.test(param)) {
    return Number(param);
  }
  return param;
};
export const _parseParams = (paramString = '') => {
  const params = [];
  for (let start = 0, end = 0; start < paramString.length; start = ++end) {
    const startingChar = paramString[start];
    if (startingChar === '"') {
      while (paramString[++end] !== startingChar && end < paramString.length);
      const string = paramString.substring(start + 1, end); // Exclude quotes
      params.push(string);
      continue;
    }
    if (startingChar === ',') {
      // Possible blank params.
      if (start === 0 || paramString[start - 1] === ',') {
        params.push(null);
      }
      continue;
    }
    if (startingChar === ' ') {
      continue;
    }
    while (paramString[++end] !== ',' && paramString[end] !== ' ' && end < paramString.length);
    const param = paramString.substring(start, end);
    params.push(getTypedValue(param));
  }
  return params;
};
export const fromFilterString = filterStr => {
  if (!filterStr) {
    return {
      filterName: '',
      parsedParams: []
    };
  }
  const matches = filterStr.match(supportedHubLFiltersRegex);
  if (!matches) {
    return {
      filterName: filterStr,
      parsedParams: []
    };
  }
  const [__, supportedFilterName, ___, paramString] = matches;
  return {
    filterName: supportedFilterName,
    parsedParams: _parseParams(paramString)
  };
};
const trailingCommaRegex = /,+$/;
const trimEmptyOptionalParams = params => {
  for (let index = params.length; index > 0; --index) {
    const {
      emptyValue,
      required,
      value
    } = params[index - 1];
    const isEmpty = [null, undefined, emptyValue].includes(value);
    if (isEmpty && !required) {
      continue;
    } else {
      // Abort on the first non-empty or required value.
      return params.slice(0, index);
    }
  }
  return [];
};
export const toFilterString = ({
  filterName,
  params = []
}) => {
  if (params.length === 0) {
    return filterName;
  }
  const paramString = trimEmptyOptionalParams(params).map(({
    type,
    value
  }) => type === 'string' ? `"${value}"` : value).join(',').replace(trailingCommaRegex, '');
  return `${filterName}(${paramString})`;
};